import React, { useEffect, useState } from 'react';
import { Mail, Phone, Download, Sparkles, Award, BookOpen, Users } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const stats = [
    { icon: <BookOpen size={24} />, value: '50+', label: 'Publications' },
    { icon: <Users size={24} />, value: '13+', label: 'Students Supervised' },
    { icon: <Award size={24} />, value: '6', label: 'Research Scholars' },
  ];

  return (
    <section id="hero" className="pt-32 pb-20 bg-gradient-to-br from-blue-50 via-cyan-50 to-purple-50 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-float"></div>
      <div className="absolute top-40 right-10 w-72 h-72 bg-cyan-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-float" style={{ animationDelay: '1s' }}></div>
      <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-float" style={{ animationDelay: '2s' }}></div>

      <div className="w-full px-12 relative z-10">
        <div className={`flex flex-col lg:flex-row items-center gap-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {/* Profile Image */}
          <div className="flex-shrink-0">
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-cyan-500 to-purple-600 rounded-full blur-2xl opacity-50 group-hover:opacity-70 transition-opacity duration-500"></div>
              <div className="relative w-80 h-80 rounded-full overflow-hidden border-8 border-white shadow-2xl transform group-hover:scale-105 transition-transform duration-500">
                <img
                  src="https://customer-assets.emergentagent.com/job_research-profile-10/artifacts/kzhqlmqp_Gemini_Generated_Image_pgpdhfpgpdhfpgpd.png"
                  alt="Dr. Nelson Muthu"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -top-4 -right-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white p-4 rounded-full shadow-lg animate-pulse">
                <Sparkles size={32} />
              </div>
            </div>
          </div>

          {/* Profile Info */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-block mb-4">
              <span className="px-4 py-2 bg-gradient-to-r from-blue-600 to-cyan-500 text-white text-sm font-semibold rounded-full shadow-lg">
                Associate Professor
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-bold mb-4">
              <span className="bg-gradient-to-r from-blue-600 via-cyan-500 to-purple-600 bg-clip-text text-transparent">
                Dr. Nelson Muthu
              </span>
            </h1>
            
            <div className="text-xl lg:text-2xl text-slate-600 mb-6 font-medium">
              <p className="mb-2">Mechanical Engineering Department</p>
              <p className="text-lg text-slate-500">Indian Institute of Technology Palakkad</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-3 mb-8 max-w-2xl">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="bg-white/80 backdrop-blur-sm rounded-2xl p-3 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  <div className="text-blue-600 mb-1 flex justify-center">{stat.icon}</div>
                  <div className="text-xl font-bold text-slate-800">{stat.value}</div>
                  <div className="text-xs text-slate-600">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mb-8 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-slate-600 bg-white px-4 py-3 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <Mail size={20} className="text-blue-600" />
                <span className="font-medium">nelsonm@iitpkd.ac.in</span>
              </div>
            </div>

            <div className="flex flex-wrap gap-4 justify-center lg:justify-start">
              <Button
                asChild
                className="bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white px-8 py-6 text-lg shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
              >
                <a href="mailto:nelsonm@iitpkd.ac.in">
                  <Mail className="mr-2" size={20} />
                  Get in Touch
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-6 text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                <a href="/Dr_Nelson_Muthu_CV.docx" download="Dr_Nelson_Muthu_CV.docx">
                  <Download className="mr-2" size={20} />
                  Download CV
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;